module.exports = __webpack_public_path__ + "static/media/icon_logout.577346c0.svg";